module.exports = __webpack_public_path__ + "static/media/MockPhone12.0a3dd5a7.png";